import axiosInstance from './axiosConfig';

export interface AgentGroup {
  category: string;
  agents: Array<{
    id: number;
    title: string;
    base_color: string;
    description?: string;
    category?: string;
  }>;
}

/**
 * カテゴリー別にグループ化されたAIエージェントを取得
 * @returns カテゴリー別エージェント情報
 */
export const getCategorizedAgents = async (): Promise<{
  personalAgents: AgentGroup;
  organizationAgents: AgentGroup;
  allAgents: any[];
}> => {
  try {
    const response = await axiosInstance.get('/ai-agents/categorized');
    return response.data.data;
  } catch (error) {
    console.error('カテゴリ別AIエージェント取得に失敗しました:', error);
    return {
      personalAgents: { category: 'あなたがよく使うAI', agents: [] },
      organizationAgents: { category: '組織がよく使うAI', agents: [] },
      allAgents: []
    };
  }
};
